import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: {
      title: 'GoocH.me | Random musings about tech',
      metaTags: [
        {
          name: 'description',
          content: 'Random musings about tech'
        },
        {
          property: 'og:description',
          content: 'Random musings about tech'
        }
      ]
    },
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/blog',
    meta: {
      title: 'GoocH.me | Random musings about tech',
      metaTags: [
        {
          name: 'description',
          content: 'Random musings about tech'
        },
        {
          property: 'og:description',
          content: 'Random musings about tech'
        }
      ]
    },
    name: 'blog',
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/blog/:category',
    meta: {
      title: 'GoocH.me | Random musings about tech',
      metaTags: [
        {
          name: 'description',
          content: 'Random musings about tech'
        },
        {
          property: 'og:description',
          content: 'Random musings about tech'
        }
      ]
    },
    name: 'blog/category',
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/blog/post/:post',
    meta: {
      title: 'GoocH.me | Random musings about tech',
      metaTags: [
        {
          name: 'description',
          content: 'Random musings about tech'
        },
        {
          property: 'og:description',
          content: 'Random musings about tech'
        }
      ]
    },
    name: 'blog/post',
    component: () => import('../views/Post.vue')
  },
  {
    path: '/contact',
    meta: {
      title: 'GoocH.me | Random musings about tech',
      metaTags: [
        {
          name: 'description',
          content: 'Random musings about tech'
        },
        {
          property: 'og:description',
          content: 'Random musings about tech'
        }
      ]
    },
    name: 'contact',
    component: () => import('../views/Contact.vue')
  }
]

// TODO: make a 404 page

const router = new VueRouter({
  routes
})

export default router
